import { createVolume, deleteVolume, renameVolume, resizeVolume } from './api';

export const createVolumeMutation = () => ({
  mutationFn: createVolume,
});

export const deleteVolumeMutation = () => ({
  mutationFn: deleteVolume,
});

export const deleteVolumesMutation = () => ({
  mutationFn: (uuids: string[]) => Promise.all(uuids.map(deleteVolume)),
});

export const renameVolumeMutation = () => ({
  mutationFn: (payload: { uuid: string; name: string; action: string }) =>
    renameVolume(payload.uuid, { name: payload.name, action: payload.action }),
});

export const resizeVolumeMutation = () => ({
  mutationFn: (payload: { uuid: string; size_gigabytes: number; action: string }) =>
    resizeVolume(payload.uuid, { size_gigabytes: payload.size_gigabytes, action: payload.action }),
});
